import React from "react";
import { useTranslation } from "react-i18next";

import { RealityCheckDataItem } from "@data-types/reality-check";

export default function DataTable(props: {
	title: string;
	isAllowed: boolean;
	data?: RealityCheckDataItem;
}) {
	const { t } = useTranslation();

	if (props.data == null || !props.isAllowed) {
		return null;
	}

	return (
		<table className="table--primary table--reality u-mar--bottom--xsml">
			<thead className="table--primary__header table--primary__header--light">
				<tr className="table--primary__header__row">
					<th className="table--primary__header__data" colSpan={2}>
						{t<string>(props.title)}
					</th>
				</tr>
			</thead>
			<tbody className="table--primary__body">
				<tr className="table--primary__body__row">
					<td className="table--primary__body__data">
						{t<string>("SESSION.REALITY_CHECK.NUM_BETS")}:
					</td>
					<td className="table--primary__body__data table--primary__body__value">
						{props.data.numberOfBets}
					</td>
				</tr>
				<tr className="table--primary__body__row">
					<td className="table--primary__body__data">
						{t<string>("SESSION.REALITY_CHECK.GAIN")}:
					</td>
					<td className="table--primary__body__data table--primary__body__value">
						{props.data.gain}
					</td>
				</tr>
				<tr className="table--primary__body__row">
					<td className="table--primary__body__data">
						{t<string>("SESSION.REALITY_CHECK.LOSS")}:
					</td>
					<td className="table--primary__body__data table--primary__body__value">
						{props.data.loss}
					</td>
				</tr>
				<tr className="table--primary__body__row">
					<td className="table--primary__body__data">
						{t<string>("SESSION.REALITY_CHECK.STAKE")}:
					</td>
					<td className="table--primary__body__data table--primary__body__value">
						{props.data.stake}
					</td>
				</tr>
			</tbody>
		</table>
	);
}
